module.exports = __webpack_public_path__ + "static/media/sati_logo.56584100.png";